import {Component} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {
    DxDateRangeBoxComponent,
    DxFileUploaderComponent,
    DxFormComponent,
    DxTextAreaComponent,
    DxValidatorComponent
} from "devextreme-angular";
import {DxiItemComponent, DxiValidationRuleComponent} from "devextreme-angular/ui/nested";
import {PicturedItemSelectBoxComponent} from "../../../../../components";
import {TimeOffRequestModalComponent} from "../../time-off-request-modal/time-off-request-modal.component";
import TimeOffPopupComponent from "../../time-off-popup.component";
import {
    AccessType,
    ChangeLeaveOfAbsenceStatusCommand, CreateLeaveOfAbsenceCommand, EmployeeDto, LeaveOfAbsenceGridViewDto,
    PermissionType, TimeOffStatus, UploadedFileDto
} from "@services";
import moment from "moment/moment";
import { FileUtils } from 'src/app/shared/file-utils';

@Component({
    selector: 'app-absence-popup',
    imports: [
        AsyncPipe,
        DxDateRangeBoxComponent,
        DxFormComponent,
        DxTextAreaComponent,
        DxValidatorComponent,
        DxiItemComponent,
        DxiValidationRuleComponent,
        PicturedItemSelectBoxComponent,
        TimeOffRequestModalComponent,
        DxFileUploaderComponent
    ],
    templateUrl: './absence-popup.component.html',
    styleUrl: './absence-popup.component.scss',
})
export class AbsencePopupComponent extends TimeOffPopupComponent<LeaveOfAbsenceGridViewDto> {
    files: File[] = [];

    async onSave() {
        const uploadedFiles = await FileUtils.mapFilesToDto(this.files);

        let createLieuDayCommand = new CreateLeaveOfAbsenceCommand({
            requestedStartDate: this.formData.requestedStartDate,
            requestedEndDate: this.formData.requestedEndDate,
            userId: this.formData.employee.id,
            description: this.formData.description,
            uploadedFiles: uploadedFiles
        });

        this.timeOffClient.createLeaveOfAbsence(createLieuDayCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    };
    
    async loadData() {
        if (this.request) {
            this.formData = new LeaveOfAbsenceGridViewDto();
            this.formData.init(this.request);
        } else {
            this.formData = new LeaveOfAbsenceGridViewDto();
            this.formData.init({
                employee: this.canShowInSelectBox ? new EmployeeDto({id: this.auth.userId}) : new EmployeeDto()
            });
            this.formData.requestedStartDate = null;
            this.formData.requestedEndDate = null
        }
        this.employeeId.next(this.formData.employee.id);
        this.startDate.next(this.formData.requestedStartDate);
        this.endDate.next(this.formData.requestedEndDate);
    }

    changeStatus(status: TimeOffStatus) {
        let changeStatusCommand = new ChangeLeaveOfAbsenceStatusCommand({
            id: this.formData.id,
            status: status
        });

        this.timeOffClient.changeLeaveOfAbsenceStatus(changeStatusCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    }

    protected override get canApprove(): boolean {
        return super.canApprove && this.auth.checkPermission(PermissionType.LeaveOfAbsenceRequests, AccessType.Manage);
    };

    protected override get canDecline(): boolean {
        return super.canDecline && this.auth.checkPermission(PermissionType.LeaveOfAbsenceRequests, AccessType.Manage);
    };

    protected get canEditEmployee(): boolean{
        return super.canEditEmployee && this.auth.checkPermission(PermissionType.LeaveOfAbsenceRequests, AccessType.Manage);
    }
}
